import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ORG } from "../../data/costant";
import { checkToken } from "../../utils/Auth";
import Alert from "../../utils/Alert";
import { useCustomerContext } from "../../context/CustomerContext";

export default function Nav() {
  const token = checkToken();
  const navigate = useNavigate();
  const location = useLocation();

  const { customerData } = useCustomerContext();
  const customerName = customerData?.name || "My Account";
  const customerEmail = customerData?.email || "Manage your account";
  const customerInitials = customerName
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("") || "NA";
  const isAccountPage = ["/profile", "/bookings"].includes(location.pathname);

  const handelLogout = () => {
    localStorage.removeItem("token");
    Alert.success("Logout Success!");
    navigate("/");
  };
  return (
    <nav className="navbar navbar-expand-lg bg-white navbar-light shadow border-top border-5 border-primary sticky-top p-0">
      <Link
        to={'/'}
        className="navbar-brand bg-primary d-flex align-items-center px-4 px-lg-5"
      >
        <h2 className="mb-2 text-white">{ORG.name}</h2>
      </Link>
      <button
        type="button"
        className="navbar-toggler me-4"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarCollapse">
        <div className="navbar-nav ms-auto p-4 p-lg-0">
          <Link to={'/'} className="nav-item nav-link">
            Home
          </Link>
          <Link to={'/newQuote'} className="nav-item nav-link">
            Quote
          </Link>
          <Link to={'/aboutus'} className="nav-item nav-link">
            About
          </Link>
          <Link to={'/services'} className="nav-item nav-link">
            Services
          </Link>
          <Link to={'/contact'} className="nav-item nav-link">
            Contact
          </Link>
          <Link to={'/pricing'} className="nav-item nav-link">
            Pricing
          </Link>
          {!token ? (
            <Link to={"/login"} className="nav-item nav-link">
              Login
            </Link>
          ) : (
            <div className="nav-item dropdown account-nav-dropdown">
              <button
                type="button"
                className={`nav-link dropdown-toggle account-nav-trigger ${
                  isAccountPage ? "active" : ""
                }`}
                data-bs-toggle="dropdown"
                aria-expanded="false"
                aria-label="Open customer menu"
              >
                <span className="account-nav-avatar">{customerInitials}</span>
                <span className="account-nav-customer">
                  <small>Welcome back</small>
                  <strong>{customerName}</strong>
                </span>
              </button>
              <div className="dropdown-menu account-dropdown-menu fade-up m-0">
                <div className="account-dropdown-header">
                  <span className="account-dropdown-avatar">{customerInitials}</span>
                  <div>
                    <strong>{customerName}</strong>
                    <small>{customerEmail}</small>
                  </div>
                </div>
                <div className="account-dropdown-links">
                  <Link
                    to={"/profile"}
                    className={`dropdown-item ${
                      location.pathname === "/profile" ? "is-active" : ""
                    }`}
                  >
                    <span><i className="fa fa-user"></i></span>
                    <div>
                      <strong>My Profile</strong>
                      <small>Personal information</small>
                    </div>
                    <i className="fa fa-chevron-right account-dropdown-arrow"></i>
                  </Link>
                  <Link
                    to={"/bookings"}
                    className={`dropdown-item ${
                      location.pathname === "/bookings" ? "is-active" : ""
                    }`}
                  >
                    <span><i className="fa fa-clipboard-list"></i></span>
                    <div>
                      <strong>Booking History</strong>
                      <small>Track your shipments</small>
                    </div>
                    <i className="fa fa-chevron-right account-dropdown-arrow"></i>
                  </Link>
                </div>
                <div className="account-dropdown-divider"></div>
                <button
                  type="button"
                  onClick={handelLogout}
                  className="dropdown-item account-dropdown-logout"
                >
                  <span><i className="fa fa-sign-out-alt"></i></span>
                  <strong>Logout</strong>
                </button>
              </div>
            </div>
          )}
        </div>
        <h4 className="m-0 pe-lg-5 d-none d-lg-block">
          <i className="fa fa-headphones text-primary me-3"></i>91 {ORG.mobile}
        </h4>
      </div>
    </nav>
  );
}
